import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CardTemplate from 'components/ui-templates/CardTemplate';
import Button from 'components/ui-components/Button';
import { useHTTP } from 'hooks/useRequest';
import LoadingSpinner from 'components/ui-components/loaders/LoadingSpinner';
import AlertBox from 'components/ui-components/AlertBox';
import MetaHelmet from 'helpers/MetaHelmet';

const SubmissionSuccess = () => {
  const [resend, setResend] = useState(false);

  const location = useLocation();
  const formData = location.state;

  const updatedFormData = {
    ...formData,
  };

  const requestConfig = {
    url: resend ? `/mycef/account/resend_activation_email` : null,
    method: 'post',
    headers: {
      Accept: 'application/json',
    },
    data: updatedFormData,
  };
  const { data, error, loading, resetState } = useHTTP(requestConfig);

  useEffect(() => {
    let resendTimer;
    if (data || error) {
      resendTimer = setTimeout(() => {
        setResend(false);
        resetState();
      }, 5000);
    }
    return () => clearTimeout(resendTimer);
  }, [data, error]);

  return (
    <>
      <MetaHelmet />
      {resend && (data || error) && (
        <AlertBox
          variant={data ? 'success' : 'error'}
          showIcon={false}
          body={data?.message || error?.error.data.message}
          className="mb-24"
        />
      )}
      <CardTemplate
        icon="success"
        title="Account Created"
        description="Thank you for creating a CEF Trade account">
        <h2 className="ff-body fs-20 lh-1 tc-main mb-8">
          Activate your account
        </h2>

        <p className="fs-16 fw-400 tc-secondary">
          We have sent you an email with an activation link. Please check your
          inbox and follow the instructions provided in the email.
        </p>

        <h3 className="ff-body fs-16 lh-1 tc-main s-mt-30 mb-8">
          Didn&apos;t receive an email?
        </h3>

        <p className="fs-14 fw-400 tc-secondary">
          Please check your spam folder or resend the email.
        </p>

        <Button
          className="cef-btn cef-btn--feature cef-btn--xxl cef-btn--green mt-20"
          type="button"
          disabled={loading}
          handleClick={() => setResend(true)}>
          {loading ? <LoadingSpinner /> : 'Resend Email'}
        </Button>
      </CardTemplate>
    </>
  );
};

export default SubmissionSuccess;
